import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationGr from "locales/gr/translation.json"
import translationIT from "locales/it/translation.json"
import translationRS from "locales/rs/translation.json"
import translationSP from "locales/sp/ugift.json"
import translationENG from "locales/eng/ugift.json"
import translationBM from "locales/bm/translation.json"
import translationCN from "locales/cn/ugift.json"
import translationJP from "locales/jp/ugift.json"

// the translations
const resources = {
  gr: {
    translation: translationGr,
  },
  it: {
    translation: translationIT,
  },
  rs: {
    translation: translationRS,
  },
  sp: {
    translation: translationSP,
  },
  eng: {
    translation: translationENG,
  },
  bm: {
    translation: translationBM,
  },
  cn: {
    translation: translationCN,
  },
  jp: {
    translation: translationJP,
  },
}

const language = localStorage.getItem("I18N_LANGUAGE")
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "eng")
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "eng",
    fallbackLng: "eng", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
